import { render, staticRenderFns } from "./fileIcon.vue?vue&type=template&id=546c7c7d&scoped=true&"
import script from "./fileIcon.vue?vue&type=script&lang=js&"
export * from "./fileIcon.vue?vue&type=script&lang=js&"
import style0 from "./fileIcon.vue?vue&type=style&index=0&id=546c7c7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546c7c7d",
  null
  
)

export default component.exports